<template>
<div>
  <v-container style="text-align: center;">
    <v-icon size="300px" color="red">mdi-close</v-icon>
    <h1>Payment Failed</h1>
    <v-btn class="my-5" href="/events" depressed color="primary" >Retry Payment</v-btn>
  </v-container>
</div>
</template>

<script>
export default {
  name: "PaymentFailure",
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped></style>
